
import {
    IButtonFieldConfigurationClient,
    IButtonFieldConfigurationServer,
} from "./interface";

export const transformButtonConfigClientToServer = (
    fieldConfigClient: IButtonFieldConfigurationClient
): IButtonFieldConfigurationServer => {
    const {placeholder, buttonStyles, buttonText, backgroundEffect, backgroundStroke , buttonAction } = fieldConfigClient;
    const fieldConfigServer: IButtonFieldConfigurationServer = {
        placeholder:placeholder,
        buttonStyles: buttonStyles,
        buttonText: buttonText,
        backgroundEffect: backgroundEffect,
        backgroundStroke: backgroundStroke,
        buttonAction: buttonAction ,
    };
    return fieldConfigServer;
};

export const transformButtonConfigServerToClient = (
    fieldConfigServer: IButtonFieldConfigurationServer
): IButtonFieldConfigurationClient => {
    const { placeholder ,buttonStyles, buttonText, backgroundEffect, backgroundStroke , buttonAction } = fieldConfigServer;
    const fieldConfigClient: IButtonFieldConfigurationClient = {
        placeholder:placeholder,
        buttonStyles: buttonStyles,
        buttonText: buttonText,
        backgroundEffect: backgroundEffect,
        backgroundStroke: backgroundStroke,
        buttonAction : buttonAction,

    };
    return fieldConfigClient;
};
